import { unreadMessageBadgeCount } from '../../../util/portal-chat-unread-badge';

/**
 * Todos los juicios: requerimientos de todos los flujos de Gestión Juicios en una grilla.
 * Sin Angular, para poder probarlo en Node.
 */

export interface OrdenTodosJuicios {
  key: string;
  dir: 'asc' | 'desc';
}

export interface EstadoTodosJuicios {
  pagina: number;
  tamano: number;
  busqueda?: string;
  cliente?: string;
  competencia?: string;
  /** YYYY-MM-DD. */
  desde?: string;
  hasta?: string;
  etapaPjud?: string;
  estadoPjud?: string;
  estadoNegocio?: string;
  /** Id del flujo (requirementtypeid). */
  tipoJuicio?: number | null;
  orden?: OrdenTodosJuicios | null;
}

export interface FiltrosTodosJuicios {
  cliente?: string;
  competencia?: string;
  fechaIngreso?: { desde?: string; hasta?: string };
  etapaPjud?: string;
  estadoPjud?: string;
  estadoNegocio?: string;
  tipoJuicio?: number;
}

export interface TipoJuicioOpcion {
  id: number;
  name: string;
}

export interface CuerpoTodosJuicios {
  suitemodule: 'juicios';
  start: number;
  length: number;
  search: string;
  order: OrdenTodosJuicios | null;
  filters: FiltrosTodosJuicios;
}

export interface ColumnaTodosJuicios {
  key: string;
  name: string;
  sortable: boolean;
}

const texto = (valor: string | null | undefined) => (valor ?? '').trim();

export interface FechaCalendario {
  year: number;
  month: number;
  day: number;
}

/**
 * Rango del calendario de Fecha ingreso. Sin esto ng-bootstrap solo deja ±10 años desde hoy,
 * y hay juicios ingresados mucho antes.
 */
export function limitesFechaIngreso(hoy: Date = new Date()): { min: FechaCalendario; max: FechaCalendario } {
  return {
    min: { year: 1900, month: 1, day: 1 },
    max: { year: hoy.getFullYear() + 10, month: 12, day: 31 },
  };
}

/** Fecha del datepicker de ng-bootstrap → YYYY-MM-DD; '' si está incompleta. */
export function fechaIso(fecha: { year?: number | null; month?: number | null; day?: number | null } | null | undefined): string {
  const { year, month, day } = fecha ?? {};
  if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) return '';
  const dos = (n: number) => String(n).padStart(2, '0');
  return `${String(year).padStart(4, '0')}-${dos(month as number)}-${dos(day as number)}`;
}

/** Cuerpo de POST /trackvision/requirement/list/bymodule. */
export function cuerpoTodosJuicios(estado: EstadoTodosJuicios): CuerpoTodosJuicios {
  const filters: FiltrosTodosJuicios = {};
  for (const key of ['cliente', 'competencia', 'etapaPjud', 'estadoPjud', 'estadoNegocio'] as const) {
    const valor = texto(estado[key]);
    if (valor) filters[key] = valor;
  }
  if (Number.isInteger(estado.tipoJuicio) && (estado.tipoJuicio as number) > 0) {
    filters.tipoJuicio = estado.tipoJuicio as number;
  }

  const fecha: { desde?: string; hasta?: string } = {};
  const desde = texto(estado.desde);
  const hasta = texto(estado.hasta);
  if (desde) fecha.desde = desde;
  if (hasta) fecha.hasta = hasta;
  if (desde || hasta) filters.fechaIngreso = fecha;

  const pagina = Math.max(1, Math.floor(estado.pagina || 1));
  return {
    suitemodule: 'juicios',
    start: (pagina - 1) * estado.tamano,
    length: estado.tamano,
    search: texto(estado.busqueda),
    order: estado.orden ?? null,
    filters,
  };
}

/** asc → desc → orden por defecto; otra columna empieza en asc. */
export function ordenTrasPulsar(actual: OrdenTodosJuicios | null, key: string): OrdenTodosJuicios | null {
  if (!actual || actual.key !== key) return { key, dir: 'asc' };
  return actual.dir === 'asc' ? { key, dir: 'desc' } : null;
}

/** Vista clásica: flag del dominio, permiso de Flows y al menos un flujo de juicio. */
/** Badge verde de Todos los juicios: mensajes del cliente sin leer de los grupos de juicio. */
export function mensajesSinLeerTodosJuicios(
  grupos: Array<{ suitemodule?: string | null; unreadClientMessageCount?: number }> | null | undefined,
): number {
  return (grupos ?? [])
    .filter((g) => g?.suitemodule === 'juicios')
    .reduce((total, g) => total + unreadMessageBadgeCount(g.unreadClientMessageCount), 0);
}

export function todosJuiciosVisible(
  flag: boolean,
  permiso: boolean,
  grupos: Array<{ suitemodule?: string | null }> | null | undefined,
): boolean {
  return flag && permiso && (grupos ?? []).some((g) => g?.suitemodule === 'juicios');
}
